<era-alarm-ui [alarm]="currentAlarm()"></era-alarm-ui>